import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { BauteilWithReports } from "@partikelart/portal/shared-typing";
import { Table, TableModule } from "primeng/table";
import { updateSelectionForAllParts, updateSelectionForSelectedPart } from "../+state/export.actions";
import { currentPartsForUserForExport } from "../+state/export.selectors";
import { DataExportService } from "../data-export.service";

@Component({
	selector: "partikelart-multi-export-part-table",
	templateUrl: "./multi-export-part-table.component.html",
	styleUrls: ["./multi-export-part-table.component.scss"],
	standalone: true,
	imports: [TableModule, TranslatePipe],
})
export class MultiExportPartTableComponent implements OnInit, AfterViewInit {
	@ViewChild("dt") table: Table;
	@Input() parts: BauteilWithReports[];
	@Output() selectedReportsEvent = new EventEmitter<BauteilWithReports[]>();
	selectedParts: BauteilWithReports[];
	constructor(
		private exportService: DataExportService,
		private translate: TranslateService,
		private store: Store,
	) {}

	ngOnInit(): void {
		this.store
			.select(currentPartsForUserForExport)
			.subscribe((data) => (this.selectedParts = data.filter((part) => part.selected == true)));
	}
	onRowSelect(event: any): void {
		this.store.dispatch(
			updateSelectionForSelectedPart({
				partNumber: event.data.artnr,
				selection: true,
			}),
		);
	}
	onRowUnselect(event: any): void {
		this.store.dispatch(
			updateSelectionForSelectedPart({
				partNumber: event.data.artnr,
				selection: false,
			}),
		);
	}
	onHeaderCheckboxToggle(event: any): void {
		this.store.dispatch(updateSelectionForAllParts({ selection: event.checked }));
	}
	ngAfterViewInit() {
		if (this.table != null) {
			this.table.resetScrollTop = function () {
				// emptry for some reason
			};
		}
	}
}
